import { UniButton } from '@/design-system/components/buttons';
import { Icon } from '@/design-system/components/icons/Icon';
import { H6, TextBody, TextCaption, TextTitle } from '@/design-system/components/typography';
import { LayoutContext } from 'contexts/LayoutContext';
import { SxProp, View, Image, useDripsyTheme, styled } from 'dripsy';
import _ from 'lodash';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row } from '@/design-system/components/layout';
import { formatAmountByDecimals } from '@/utils/numberFormatting';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { SetCardLimitStackParamList } from './type';
import { PageHeaderModalNative } from '../page/PageHeaderModalNative';
import moment from 'moment-timezone';
import { CardWithLimitProp } from '../../types';
import { CardLimitPlaced, CardLimitTitle } from '../../options';

export interface SetCardLimitProps {
  onClose: () => void;
  onLayout: (event: any) => void;
  dailyLimitType: string | undefined;
  data: any;
  account: string;
  tab?: number;
  record?: CardWithLimitProp;
  returnData?: any;
  refresh?: () => void;
}

export const PlacedNativeScreen: React.FC<SetCardLimitProps> = (props) => {
  const { onClose, onLayout, dailyLimitType, data, account, tab, record, returnData, refresh } = props;
  const { t } = useTranslation('account-management');
  const [selected, setSelected] = useState<boolean>(false);
  const layout = useContext(LayoutContext);

  const { theme } = useDripsyTheme();

  const navigation = useNavigation<NativeStackNavigationProp<SetCardLimitStackParamList>>();

  const [instructionTime, setInstructionTime] = useState(moment().format('YYYY-MM-DD HH:mm:ss'));

  return (
    <View sx={{ height: '100%', backgroundColor: '$white' }}>
      <PageHeaderModalNative>
        <Row sx={{ justifyContent: 'center', alignItems: 'center', px: '$4', mt: '$5', mb: '$4' }}>
          <View sx={{ textAlign: 'center' }}>
            <TextTitle bold sx={{ color: theme?.colors?.$white as string }}>
              {t('card-account-management::set-card-limit.title--daily-purchase-limit')}
            </TextTitle>
          </View>
        </Row>
      </PageHeaderModalNative>
      <View sx={styles.modal}>
        <View sx={styles.topHeader}>
          <Icon name="successSpecial" height={80} width={80} />
          <View sx={styles.textMb}>
            <H6 bold>{CardLimitPlaced(t).find((e) => e.value == dailyLimitType)?.label}</H6>
            <TextCaption>{CardLimitPlaced(t).find((e) => e.value == dailyLimitType)?.label}</TextCaption>
          </View>
        </View>
        <View sx={styles.body}>
          <TextCaption sx={styles.textTitle} bold>
            {CardLimitTitle(t).find((e) => e.value == dailyLimitType)?.label}
          </TextCaption>
          <TextBody bold sx={styles.textAtmPin}>
            {data.isEnabled
              ? t('card-account-management::set-card-limit.text--entire-secured-credit-limit')
              : formatAmountByDecimals({ value: data.value, decimals: 2, suffix: record?.currency || 'HKD' })}
          </TextBody>
          <View sx={{ gap: 12 }}>
            <TextBody sx={styles.itemStyle}>
              <TextBody secondary>{t('card-account-management::lock-card.text--instruction-time')}</TextBody>
              <TextBody>{returnData?.instructionTime || instructionTime || '-'}</TextBody>
            </TextBody>
            {/* <TextBody sx={styles.itemStyle}>
              <TextBody secondary>{t('card-account-management::lock-card.text--ref-id')}</TextBody>
              <TextBody>{returnData?.refId || '-'}</TextBody>
            </TextBody> */}
          </View>
          <View sx={styles.buttonBox}>
            <UniButton
              sx={{ width: '100%', height: 44 }}
              labelSx={{ color: '$balck' }}
              label={t('card-account-management::general.button--close')}
              onPress={() => {
                refresh && refresh();
                navigation.getParent()?.goBack();
              }}
            />
          </View>
        </View>
      </View>
    </View>
  );
};

const styles: Record<string, SxProp> = {
  modal: {
    padding: '$5'
  },
  topHeader: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: '$10'
  },
  textMb: {
    textAlign: 'center',
    gap: 8
  },
  itemStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 20
  },
  textTitle: {
    fontSize: '$1',
    marginBottom: 4,
    color: '$textSecondary'
  },
  textAtmPin: {
    fontSize: '$4',
    color: '$textThemeSecondary',
    mb: '$5'
  },
  buttonBox: {
    width: '92%',
    position: 'fixed',
    left: 0,
    bottom: 0,
    marginX: 15,
    marginBottom: 30
  }
};
